"use strict";

const $ = jQuery;

module.exports = class {
	#$module;
    #$accordion;
    #$toggle;
    #$siteHeader;
    #$siteHeaderNavBar;

	#data;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$accordion = $module.find('.accordion');
        this.#$toggle = $module.find('.accordion-header > .accordion-button');
        this.#$siteHeader = $('body > header');
        this.#$siteHeaderNavBar = this.#$siteHeader.find('nav.navbar');

        // this.bind();

        requestAnimationFrame(() => {
            if (location.hash === `#${this.id}` || location.hash === `#${this.moduleId}`) {
                if (!this.isExpanded()) {
                    this.#$toggle.trigger('click');
                }
                
                this.scrollTo();
            }
        });
	}

    bind() {
        this.$accordion.on('show.bs.collapse', (event) => { this.onAccordionShow(event); });
        this.$accordion.on('shown.bs.collapse', (event) => { this.onAccordionShown(event); });
        this.$accordion.on('hide.bs.collapse', (event) => { this.onAccordionHide(event); });
        this.$accordion.on('hidden.bs.collapse', (event) => { this.onAccordionHidden(event); });
        $('html').on(`bb-lumeris:lum-simple-accordion:${this.data.parent}:close`, (event, data) => { return this.onTriggerAccordionClose(event, data); });
    }

    get $module() {
        return this.#$module;
    }

    get $accordion() {
        return this.#$accordion;
    }

    get $toggle() {
        return this.#$toggle;
    }

    get $siteHeader() {
        return this.#$siteHeader;
    }

    get $siteHeaderNavBar() {
        return this.#$siteHeaderNavBar;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.settings.id;
    }

    get moduleId() {
        return this.data.node;
    }

    isExpanded() {
        return (this.$toggle.hasClass('collapsed') && this.$toggle.attr('aria-expanded') === 'false') ? false : true;
    }

    scrollTo() {
        const scrollTopMargin = Number(this.$module.css('scroll-margin-top').split('px').join('')) || Number(this.$accordion.css('scroll-margin-top').split('px').join(''));
        $(window).scrollTop(this.$module.offset().top - this.$siteHeaderNavBar.height() - scrollTopMargin);
    }
    
    onAccordionShow(event) {
        if (event.namespace !== 'bs.collapse' || event.type !== 'show') {
			return null;
		}

        $('html').trigger(`bb-lumeris:lum-simple-accordion:${this.data.parent}:close`, { moduleId: this.moduleId });
    }

    onAccordionShown(event) {
        if (event.namespace !== 'bs.collapse' || event.type !== 'shown') {
			return null;
		}
    }

    onAccordionHide(event, data) {
        if (event.namespace !== 'bs.collapse' || event.type !== 'hide') {
			return null;
		}
    }

    onAccordionHidden(event, data) {
        if (event.namespace !== 'bs.collapse' || event.type !== 'hidden') {
			return null;
		}
    }

    onTriggerAccordionClose(event, data) {
        if (event.type !== `bb-lumeris:lum-simple-accordion:${this.data.parent}:close`) {
            return null;
        }

        if (data.moduleId === this.moduleId) {
            return null;
        }
    }
}